module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'anchor/base' && templateVars.config ?
				templateVars.config :
				{
	"scrollDuration": 1000,
	"heightFixedHead": 0,
	"removeTargetAnchor": 250
};